import { toast } from "@jti/core-components/components/Toaster";
import type { Dictionary } from "@jti/fe-common";
import { translateBackendErrorCode } from "@jti/fe-common";

type BackendError = { error_code?: string; message?: string };

const isBackendError = (error: unknown): error is BackendError => typeof error === "object" && error !== null;

export const displayToastError = (error: unknown, customErrorMessage?: string, dictionary: Dictionary = {}) => {
  const typedError = isBackendError(error) ? error : undefined;
  const translatedError = translateBackendErrorCode(typedError?.error_code, undefined, dictionary);
  const generalDefaultErrorMessage = translateBackendErrorCode(
    "tenant::general_response_error_message",
    undefined,
    dictionary
  );
  const errorMessage = translatedError || customErrorMessage || generalDefaultErrorMessage || typedError?.message;

  if (errorMessage) {
    toast.error(errorMessage);
  }
};
